<ng-template #modal>
  <router-outlet></router-outlet>
</ng-template>
